import {
  buildMarketDataCandleKeys,
  buildMarketDataKeys,
} from '../../../../../../../stores/websocketStore/utils/marketDataRouting';

function normalizeTimeUnit(value) {
  if (value == null) {
    return '';
  }

  return String(value).trim().toUpperCase();
}

function normalizeDuration(value) {
  const normalized = Number(value);
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return null;
  }

  return normalized;
}

function candleMatchesRequestedTimeframe(candle, timeUnit, candleDuration) {
  const candleTimeUnit = normalizeTimeUnit(candle?.timeUnit);
  const requestedTimeUnit = normalizeTimeUnit(timeUnit);
  const candleTimeframe = normalizeDuration(
    candle?.candleDuration ?? candle?.duration
  );
  const requestedDuration = normalizeDuration(candleDuration);

  if (!candleTimeUnit || candleTimeframe == null) {
    return true;
  }

  return (
    candleTimeUnit === requestedTimeUnit &&
    candleTimeframe === requestedDuration
  );
}

export function resolveLiveCandleForChart({
  candles,
  symbol,
  dataSource,
  brokerage,
  hash,
  timeUnit,
  candleDuration,
}) {
  const candleKeys = buildMarketDataCandleKeys({
    symbol,
    dataSource,
    brokerage,
    timeUnit,
    candleDuration,
  });
  const exactMatch = candleKeys.find((key) => candles[key]);
  if (exactMatch) {
    return candles[exactMatch];
  }

  if (`${timeUnit ?? ''}`.toUpperCase() !== 'MINUTES') {
    return null;
  }

  const fallbackKey =
    buildMarketDataKeys({ symbol, dataSource, brokerage }).find(
      (key) => candles[key]
    ) ?? hash;

  const fallbackCandle = candles[fallbackKey] ?? null;
  if (
    !candleMatchesRequestedTimeframe(
      fallbackCandle,
      timeUnit,
      candleDuration
    )
  ) {
    return null;
  }

  return fallbackCandle;
}
